import React, { createContext, useContext, useMemo, useRef } from 'react';
import { Toast } from 'primereact/toast';

const ToastContext = createContext();

export const ToastProvider = ({ children }) => {
    const toast = useRef(null);

    const showToast = (severity, summary, detail, life = 3000) => {
        toast.current?.show({ severity, summary, detail, life });
    };

    const showToastObj = (toastObj) => {
        toast.current?.show(toastObj);
    };

    // The toast ref is stable, so the context value only needs to be created once.
    const value = useMemo(() => ({ showToast, showToastObj }), []);

    return (
        <ToastContext.Provider value={value}>
            <Toast ref={toast} />
            {children}
        </ToastContext.Provider>
    );
};

export const useToast = () => {
    const context = useContext(ToastContext);
    if (!context) {
        throw new Error('useToast must be used within a ToastProvider');
    }
    return context;
};
